"use client";

import { useCallback } from 'react';
import { useRouter } from 'next/navigation';

interface FilterClientWrapperProps {
  children: ((props: {
    handleSlugChange: (newSlug: string) => void;
  }) => React.ReactNode) | React.ReactNode;
}

const FilterClientWrapper = ({ children }: FilterClientWrapperProps) => {
  const router = useRouter();

  const handleSlugChange = useCallback((newSlug: string) => {
    router.push(`/collection/${newSlug}`);
  }, [router]);

  return (
    <>
      {typeof children === 'function' 
        ? children({ handleSlugChange })
        : children
      }
    </>
  );
};

export default FilterClientWrapper; 